import React, { useEffect } from 'react';
import { initMetaPixel } from './utils/pixel';
import { UrgencyBar } from './components/UrgencyBar';
import { Hero } from './components/Hero';
import { Hook } from './components/Hook';
import { Pain } from './components/Pain';
import { Method } from './components/Method';
import { Outcomes } from './components/Outcomes';
import { ValueStack } from './components/ValueStack';
import { Pricing } from './components/Pricing';
import { Guarantee } from './components/Guarantee';
import { FinalCTA } from './components/FinalCTA';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="w-full bg-ink-950 font-sans text-zinc-100" data-id="element-0" data-mp="31brzvakwgrl4">
      <UrgencyBar data-id="element-1" data-mp="2wka1mua9h53u" />
      <Hero data-id="element-2" data-mp="2wjqgl4pbe0ll" />
      <main data-id="element-3" data-mp="2wiyv4mpflj91">
        <Hook data-id="element-4" data-mp="2wifgbev2vaz8" />
        <Pain data-id="element-5" data-mp="2whx9xpepbgdl" />
        <Method data-id="element-6" data-mp="2wi5qbra193tj" />
        <Outcomes data-id="element-7" data-mp="28u5z6q8t7bef" />
        <ValueStack data-id="element-8" data-mp="28tmi1bqzgr1g" />
        <Pricing data-id="element-9" data-mp="28suu8n3mnxlq" />
        <Guarantee data-id="element-10" data-mp="28sbb5328r364" />
      </main>
      <FinalCTA data-id="element-11" data-mp="23vkuoemiy5k6" />
    </div>;
}